import styled from 'styled-components';

interface SeparatorProps {
  $top?: string | null;
  $bottom?: string | null;
}

const FooterSeparator = styled.hr<SeparatorProps>`
  margin-top: ${(props) => (props.$top ? props.$top : '2em')};
  margin-bottom: ${(props) => (props.$bottom ? props.$bottom : '1.85em')};
  border-top: 0.0625rem solid ${(props) => props.theme.colors.lightGray};
`;

export default FooterSeparator;
